import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import Progress from '@clds/progress';
import { Icon, iconMixin } from '@cld/icon';

export const StyledChildrenWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;

  ${Icon}, ${Progress.Circular} {
    margin-right: ${globalTheme.spacing.xs};
    ${(props) => iconMixin({ ...props, size: 'md' })}
    transition: fill 150ms;
    flex-shrink: 0;
  }
  ${Progress.Circular} {
    color: currentColor;
  }
`;

export default StyledChildrenWrapper;
